module.exports = __webpack_public_path__ + "static/media/BarChart.1ab5401b.svg";